import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { IGlobalState } from '../../model/IGlobalState';
import EditAnnouncementComments from './EditAnnouncementComments';
import * as Roles from '../../model/Roles';
import useAsyncEffect from 'use-async-effect';
import { loading } from '../../actions/Loading';
import Announcements from '../stock/Announcements';
import { IAnnouncementsMethods } from '../stock/EditAnnouncement';
import { startSetStock } from '../../actions/CurrentStock';
import Tabs from '../Tabs';
import AnimatedSaveButton from '../AnimatedSaveButton';
import { uppercaseFirstLetter } from '../../util/util';
import Config, { IConfigMethods } from '../stock/Config';
import EmailMarketingPage, { IEmailMarketingPageMethods } from '../stock/EmailMarketingPage';

interface IProps{
    match: { params: {  combinedTicker:string }};
    tab?:string;
}

const ConfigTabName:string = 'Config';
const CommentsTabName:string = 'Comments';
const AnnouncementsTabName:string = 'Announcements';
const EmailMarketingTabName:string = 'Email Marketing';

const Wrapper = styled.div`

`;

const ClientStockItem: React.FC<IProps> = (props:IProps) => {
    const dispatch = useDispatch();
    const ticker = props.match.params.combinedTicker
    const user = useSelector((state: IGlobalState) => state.user)
    const stock = useSelector((state: IGlobalState) => state.currentStock)
    const [ activeTab, setActiveTab ] = useState(uppercaseFirstLetter(props.tab) || '');
    const emailMarketingPage = React.createRef<IEmailMarketingPageMethods>();
    const configPage = React.createRef<IConfigMethods>();
    

    useAsyncEffect(async (isMounted:()=>boolean)=> {
        dispatch(loading(true));
        dispatch(startSetStock(ticker))
        dispatch(loading(false));
      }, []);

      const hasRole = (r:string) => stock && user.stockRoles[stock.id].includes(r)

      useAsyncEffect(async (isMounted:()=>boolean)=> {
        // if(user && stock && !activeTab){

        //     let tabDefault = ConfigTabName;
        //     if(user.stockRoles[stock.id].length===1 && hasRole(Roles.CreateCampaign)){
        //         tabDefault = EmailMarketingTabName;
        //     }
        //     setActiveTab(tabDefault)
        // }
        
      }, [ user, stock ]);

      const announcementsPage = React.createRef<IAnnouncementsMethods>();
      const onSavedAnnouncement = async () => { 
            dispatch(startSetStock(ticker))
        }

    const save = async ()=>{
        let success:boolean = false;
        if(activeTab === AnnouncementsTabName){
            success = await announcementsPage.current!.save();
        }else if(activeTab === EmailMarketingTabName){            
            success = await emailMarketingPage.current!.save();
        }else if(activeTab === ConfigTabName){            
            success = await configPage.current!.save();
        }
        return Promise.resolve(success);
    }

    const showConfig = hasRole(Roles.ViewConfig);
    const showAnnouncements = hasRole(Roles.EditAnnouncements);
    const showEmailMarketing = hasRole(Roles.EditMailchimp) || hasRole(Roles.CreateCampaign) || hasRole(Roles.TestSendAnnouncement) || hasRole(Roles.SendMailchimp)
    const showComments = hasRole(Roles.ReplyToComment);

    return <Wrapper>
    { stock && <div>

        <div className="space-between">
                <div className="space-between">
                <h1> { ticker } </h1>
                
                </div>
                
                {<AnimatedSaveButton onClick={save}  />} 
            </div>
        { user.stockRoles[stock.id].length === 0 && <p>You do not have any permissions assigned for this Stock. Please contact Investi support</p>}
        
        <Tabs onTabChanged={setActiveTab} activeTab={activeTab}>
    
        
        { showConfig  && <div data-label={ConfigTabName}>
                        <Config    
                        key={stock.id}                    
                        id={stock.id}                    
                        ticker={stock.ticker} 
                        exchange={stock.exchange}
                        
                            ref={configPage}    
                        />
                    </div>}

    { showAnnouncements && <div data-label={AnnouncementsTabName}>
                        <Announcements
                            syncInProgress={false}
                            ref={announcementsPage}
                            onSavedAnnouncement={onSavedAnnouncement}
                        />
                    </div>}

                    {showEmailMarketing && <div data-label={EmailMarketingTabName}>
                        <EmailMarketingPage                         
                        ref={emailMarketingPage}
                        />
                    </div>}


                    { showComments && <div data-label={CommentsTabName}>
                         <EditAnnouncementComments combinedTicker={ticker}
                         
                         />
                        </div>}

                        

        </Tabs>
    </div>
    
    
    }
    




</Wrapper>
}

export default ClientStockItem

